import { useEffect, useMemo } from "react";
// import logo from "./logo.svg";
import "./tailwind.css";
import "./App.scss";
import { SupportedLanguages } from "./common/controls/lang-switcher";
import { IntlProvider } from "react-intl";
import { getUserLocalization, LANG_RESOURCES } from "./locales";
import MainAppLayout from "./layouts/_main-app-layout";
import { USER_LANG_KEY } from "./locales/keys";
import { useLocalStorageState } from "./common/utils/local-storage-hook";
import AppRouter from "./routes/router";
import { Provider } from "react-redux";
import { store } from "./store/store";
import ConsentBanner from "./analytics/ConsentBanner";
import { enableMetrika, getConsent } from "./analytics/metrika";

function App() {
  console.count("App render");

  const urlLang = useMemo<SupportedLanguages | null>(() => {
    const v = new URLSearchParams(window.location.search).get("lang");
    return v === "ru" || v === "en" ? v : null;
  }, []);

  const [lang, setLanguage] = useLocalStorageState<SupportedLanguages>(
    USER_LANG_KEY,
    () => getUserLocalization(),
    urlLang,
  );

  const handleLanguageChange = (nextLang: SupportedLanguages) => {
    setLanguage(nextLang);
  };

  useEffect(() => {
    console.log("App commit");
  }, []);

  useEffect(() => {
    console.log("App language changed:", lang);
  }, [lang]);

  useEffect(() => {
    if (getConsent() === "granted") enableMetrika();
  }, []);

  const isPrintRoute = window.location.pathname.startsWith("/cv/print");

  return (
    <IntlProvider locale={lang} messages={LANG_RESOURCES[lang]}>
      <Provider store={store}>
        {isPrintRoute ? (
          <AppRouter />
        ) : (
          <MainAppLayout onLanguageChange={handleLanguageChange} language={lang}>
            <AppRouter />
            <ConsentBanner />
          </MainAppLayout>
        )}
      </Provider>
    </IntlProvider>
  );
}

export default App;
